import Seo from "../components/Seo";

export default function TermsPage() {
  const title = "เงื่อนไขการให้บริการ";

  return (
    <>
      <Seo title={title} description="รายละเอียดขอบเขตบริการ หน้าที่ของผู้ใช้บริการ การชำระเงิน การรักษาความลับ และข้อจำกัดความรับผิดของ KMCP Accounting" path="/terms" />
      <section className="mx-auto max-w-4xl px-6 py-20 sm:px-8">
        <h1 className="text-4xl font-semibold text-gray-900">เงื่อนไขการให้บริการ</h1>
        <p className="mt-4 text-sm text-gray-500">มีผลบังคับใช้: พฤศจิกายน 2568</p>
        <div className="mt-10 space-y-10 text-base leading-relaxed text-gray-700">
          <section>
            <h2 className="text-2xl font-semibold text-gray-900">1. การว่าจ้างและขอบเขตบริการ</h2>
            <p className="mt-3">
              เมื่อลูกค้าตกลงใช้บริการ KMCP Accounting ถือว่าได้อนุญาตให้ทีมงานเก็บรวบรวมเอกสารบัญชี เอกสารภาษี และข้อมูลที่จำเป็นต่อการให้บริการตามขอบเขตที่ตกลงไว้
              การเปลี่ยนแปลงขอบเขตงาน (Scope) หรือระยะเวลา ต้องได้รับการยืนยันเป็นลายลักษณ์อักษร
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900">2. ความรับผิดชอบของลูกค้า</h2>
            <ul className="mt-3 list-disc space-y-2 pl-6">
              <li>ส่งมอบเอกสารและข้อมูลที่ถูกต้อง ครบถ้วน และตรงตามกำหนดเวลา</li>
              <li>แจ้งการเปลี่ยนแปลงโครงสร้างบริษัท ผู้ถือหุ้น หรือข้อมูลสำคัญที่มีผลต่อการทำบัญชีภายใน 7 วันทำการ</li>
              <li>รักษารหัสผ่านและสิทธิ์การเข้าถึงระบบต่าง ๆ ที่มอบให้ KMCP Accounting อย่างปลอดภัย</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900">3. ค่าบริการและการชำระเงิน</h2>
            <ul className="mt-3 list-disc space-y-2 pl-6">
              <li>ค่าบริการคิดตามแพ็กเกจหรือใบเสนอราคาที่ตกลงไว้ และออกใบแจ้งหนี้ล่วงหน้าทุกเดือน</li>
              <li>ชำระเงินภายใน 15 วันนับจากวันที่ออกใบแจ้งหนี้ หากเกินกำหนด บริษัทสงวนสิทธิ์หยุดให้บริการชั่วคราวจนกว่าจะชำระครบ</li>
              <li>กรณีขอยุติบริการ ต้องแจ้งล่วงหน้าอย่างน้อย 30 วัน และชำระค่าบริการตามงานที่ดำเนินการไปแล้ว</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900">4. การรักษาความลับ</h2>
            <p className="mt-3">
              KMCP Accounting จะเก็บรักษาและใช้ข้อมูลของลูกค้าเพื่อวัตถุประสงค์ในการให้บริการเท่านั้น
              เราจะไม่เปิดเผยข้อมูลแก่บุคคลภายนอก เว้นแต่ได้รับความยินยอมจากลูกค้า หรือมีข้อกำหนดทางกฎหมายบังคับ
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900">5. การรับผิดชอบและข้อจำกัด</h2>
            <ul className="mt-3 list-disc space-y-2 pl-6">
              <li>ทีมงานรับผิดชอบความถูกต้องของงานภายในขอบเขตที่ได้รับข้อมูลถูกต้องตรงเวลา</li>
              <li>บริษัทไม่รับผิดชอบความเสียหายที่เกิดจากข้อมูลที่ไม่ครบถ้วน การแจ้งข้อมูลล่าช้า หรือเหตุการณ์นอกเหนือการควบคุม</li>
              <li>ความรับผิดสูงสุดของ KMCP Accounting ต่อความเสียหายใด ๆ จะไม่เกินค่าบริการของเดือนล่าสุด</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900">6. การยุติสัญญา</h2>
            <p className="mt-3">
              ทั้งสองฝ่ายสามารถยุติสัญญาด้วยการแจ้งล่วงหน้าเป็นลายลักษณ์อักษร 30 วัน หากมีการละเมิดข้อกำหนดร้ายแรง
              อีกฝ่ายมีสิทธิ์ยุติสัญญาได้ทันที โดยยังคงต้องชำระค่าบริการที่ค้างชำระ
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900">7. กฎหมายที่ใช้บังคับ</h2>
            <p className="mt-3">
              เงื่อนไขนี้อยู่ภายใต้กฎหมายไทย และข้อพิพาทใด ๆ จะอยู่ในอำนาจศาลของกรุงเทพมหานคร ประเทศไทย
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900">8. การแก้ไขเงื่อนไข</h2>
            <p className="mt-3">
              KMCP Accounting อาจปรับปรุงเงื่อนไขเพื่อให้สอดคล้องกับกฎหมายและการให้บริการที่เปลี่ยนแปลง
              จะประกาศวันที่มีผลบังคับใช้ไว้บนเว็บไซต์ หากลูกค้าใช้บริการต่อ ถือว่ายอมรับเงื่อนไขล่าสุด
            </p>
          </section>
        </div>
      </section>
    </>
  );
}
